import { translateText } from "./translate-text";

window.addEventListener("load", (e) => {
  // Select2 only dispatches Jquery events...
  if (jQuery) {
    jQuery("select").on("select2:open", () => {
      // Dirty hack since Select2 could be "loading" the values.
      setTimeout(function () {
        document
          .querySelectorAll(".select2-results__options li")
          .forEach((el) => translateText(el, window.shopTranslations));
      }, 100);
    });
  } else {
    console.log("JQuery not defined");
  }

  document
    .querySelectorAll(
      ".woof_container_inner h4, .woof_block_html_items .select2-selection__rendered, .select2-container .select2-results__option, .woof_block_html_items select > option, .woof_products_top_panel .woof_remove_ppi"
    )
    .forEach((el) => translateText(el, window.shopTranslations));
});
